<p>configuracion-asistencia works!</p>
